<div class="home">
  <coa-home-header></coa-home-header>
  <router-outlet></router-outlet>
</div>

